<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/elemental/products/*', { eager: true });

useHead({});

const products = [
	{
		title: "40oz Commuter Tumbler", 
		src: imagesGlob["../../images/brands/elemental/products/swaggerproductpagewebsiteelemental40oz-commuter-tumbler.png"].default
	},
	{
		title: "32oz Commuter Tumbler", 
		src: imagesGlob["../../images/brands/elemental/products/swaggerproductpagewebsiteelemental32oz-commuter-tumbler.png"].default
	},
	{
		title: "Recess 10oz Wine Tumbler", 
		src: imagesGlob["../../images/brands/elemental/products/swaggerproductpagewebsiteelementalrecess-10oz-wine-tumbler.png"].default
	},
	{
		title: "Core 18oz Pop Bottle", 
		src: imagesGlob["../../images/brands/elemental/products/swaggerproductpagewebsiteelementalcore-18oz-pop-bottle.png"].default
	},
	{
		title: "Adventure Ready Trio Gift Set", 
		src: imagesGlob["../../images/brands/elemental/products/swaggerproductpagewebsiteelementaladventure-ready-trio-gift-set.png"].default
	},
	{
		title: "Recess 10oz Rocks Tumbler", 
		src: imagesGlob["../../images/brands/elemental/products/swaggerproductpagewebsiteelementalrecess-10oz-rocks-tumbler.png"].default
	},
	{
		title: "16oz Summit Mug", 
		src: imagesGlob["../../images/brands/elemental/products/swaggerproductpagewebsiteelemental16oz-summit-mug.png"].default
	},
	{
		title: "12oz Summit Mug", 
		src: imagesGlob["../../images/brands/elemental/products/swaggerproductpagewebsiteelemental12oz-summit-mug.png"].default
	},
	{
		title: "12oz Artisan Tumbler", 
		src: imagesGlob["../../images/brands/elemental/products/swaggerproductpagewebsiteelemental12oz-artisan-tumbler.png"].default
	},
	{
		title: "Classic 25oz Water Bottle", 
		src: imagesGlob["../../images/brands/elemental/products/swaggerproductpagewebsiteelementalclassic-25oz-water-bottle.png"].default
	},
	{
		title: "Core 24oz Bottle", 
		src: imagesGlob["../../images/brands/elemental/products/swaggerproductpagewebsiteelementalcore-24oz-bottle.png"].default
	},
	{
		title: "Iconic Sport 20oz Water Bottle", 
		src: imagesGlob["../../images/brands/elemental/products/swaggerproductpagewebsiteelementaliconic-sport-20oz-water-bottle.png"].default
	},
	{
		title: "16oz Artisan Tumbler", 
		src: imagesGlob["../../images/brands/elemental/products/swaggerproductpagewebsiteelemental16oz-artisan-tumbler.png"].default
	},
	{
		title: "Commute 'n Chill Gift Set", 
		src: imagesGlob["../../images/brands/elemental/products/swaggerproductpagewebsiteelementalcommute-n-chill-gift-set.png"].default
	},
	{
		title: "Whiskey Buddy Gift Set", 
		src: imagesGlob["../../images/brands/elemental/products/swaggerproductpagewebsiteelementalwhiskey-buddy-gift-set.png"].default
	},
	{
		title: "Iconic 14oz Pop Fidget Bottle", 
		src: imagesGlob["../../images/brands/elemental/products/swaggerproductpagewebsiteelementaliconic-14oz-pop-fidget-bottle.png"].default
	}, 
]
</script>

<template lang="pug">
.page.page--brand.elemental
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/elemental/logo.png')
				h1 Custom Elemental
			.image
				img(src='@static/images/brands/elemental/hero.jpg' alt="Elemental insulated stainless steel water bottles in navy, black, speckled gray, light gray, and white, displayed on a rustic wooden table, designed for reusable hydration and eco-friendly everyday use.")
	section.section.section--subhero
		.section__content
			.copy
				h3 Refresh Your World
				p Custom Elemental Drinkware by Swagger brings color, personality, and sustainability to every sip. Founded in Southern California by Seth Inyang and Vinh Lieu, this BIPOC and AAPI-owned brand creates stainless steel bottles that are as durable as they are fun. From beachside strolls to city commutes, each bottle is designed to keep your drinks just right while letting your style shine. Live vividly, hydrate boldly, and make every sip count.

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="elemental")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/elemental/banner.png' alt='Elemental insulated coffee mugs with handles in camo, speckled gray, cream, navy, and wood grain finishes, lined up on a white background, ideal for sustainable hot and cold beverage drinking.')
			.section__content
				.copy
					h2 Hydrate with Heart
					p Every Elemental Bottle carries more than water. Eco-conscious materials, vibrant designs, and refillable durability make staying hydrated a statement for you and the planet. Plus, 3% of profits go to charities like charity: water and Bright Pink, so your bottle gives back while you sip. Practical, playful, and purposeful, Elemental Bottles turn everyday hydration into a lifestyle you can feel good about.
		
		section.section.section--foot
			.bg
			.section__content

</template>

<style></style>